import {APP_INITIALIZER, NgModule, ErrorHandler} from '@angular/core';
import {BrowserModule} from '@angular/platform-browser';
import {AppRoutingModule} from './app-routing.module';
import {AppComponent} from './app.component';
import {AuthClientConfig, AuthGuard, AuthModule} from '@auth0/auth0-angular';
import {ConfigService} from './core/config/configService';
import * as Sentry from '@sentry/angular';
import {provideHttpClient, withInterceptorsFromDi} from '@angular/common/http';
import {LoadingComponent} from "./shared/loading/loading.component";

const configFactory = (configService: ConfigService, authConfig: AuthClientConfig) => {
  return () => configService.loadConfig(authConfig);
};

@NgModule({
  declarations: [
    AppComponent
  ],
  bootstrap: [
    AppComponent
  ],
  imports: [
    AppRoutingModule,
    BrowserModule,
    AuthModule.forRoot(),
    LoadingComponent
  ],
  providers: [
    AuthGuard,
    {
      provide: ErrorHandler,
      useValue: Sentry.createErrorHandler({
        showDialog: false,
        logErrors: true,
      }),
    },
    {
      provide: APP_INITIALIZER,
      useFactory: configFactory,
      multi: true,
      deps: [ConfigService, AuthClientConfig]
    },
    provideHttpClient(withInterceptorsFromDi())
  ]
})
export class AppModule {
}
